import { DatePickerPopover } from '@opallabs/kuiper'
import { APPROVAL_GLYPH, TASK_GLYPH } from '@opallabs/lapidary'
import { newDateObject } from '../../helpers/dateHelpers'
import { isApproval } from '../../helpers/matchers'

export function glyphName(phaseType) {
  return isApproval(phaseType) ? APPROVAL_GLYPH : TASK_GLYPH
}

const getDatePickerPopover = (
  customClass,
  date,
  disabled,
  onChangeDate,
  text
) => (
  <DatePickerPopover
    allowableDates={{ start: newDateObject() }}
    classNames={customClass}
    date={date}
    dateFormat="MMM D"
    disabled={disabled}
    onChangeDate={onChangeDate}
    icon="gem-calendar"
    text={text}
  />
)

export function dateDisplay({
  disabled,
  dueDate,
  hideDate,
  isComplete,
  onChangeDate,
  unscheduledDateText = 'Schedule',
}) {
  if (hideDate) {
    return null
  }

  let customClass = 'phase-header-date'

  if (isComplete) {
    return null
  }

  if (!isComplete && dueDate && dueDate.isValid()) {
    const now = newDateObject()
    const timeDiffInDays = dueDate.diff(now, 'days')
    const warningDays = 2
    let text = ''

    if (timeDiffInDays < 0) {
      customClass = 'phase-header-date date-warn'
      text = 'Overdue:'
    } else if (timeDiffInDays >= 0 && timeDiffInDays < warningDays) {
      customClass = 'phase-header-date date-warn'
      text = 'Due Soon:'
    }
    return getDatePickerPopover(
      customClass,
      dueDate,
      disabled,
      onChangeDate,
      text
    )
  }
  return getDatePickerPopover(
    customClass,
    dueDate,
    disabled,
    onChangeDate,
    unscheduledDateText
  )
}
